import { DOCUMENT } from '@angular/common';
import { inject, Service } from '@angular/core';

@Service()
export class I18nHtmlLangService {
    private readonly document = inject(DOCUMENT);

    setLang(lang: string): void {
        const ln = lang.split('-')[0];
        this.document.documentElement.lang = ln;
    }
}
